import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../../tools/AppConfig";
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';
import Waiting from './../waiting';
import './../../custom.css';
import './../../pages/invoice.css';
import CashSubData from './../../modules/paymentMethods/cashSubData';

class cash extends Component {
      constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            phone: '',
            editBtn:this.props.editBtn
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handelPhoneChange = this.handelPhoneChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);

      }

    getFirstName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[0]
    }
    getLastName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[namesArr.length - 1];
    }
  handelPhoneChange(e) {
    this.setState({phone: e.target.value});
  }
  handleEdit(){
    this.setState({editBtn: !this.state.editBtn});
  }
  handleSubmit(event) {
    //--- strat waiting
    this.setState({waiting: true});
    let url;
    if(this.props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice_prem/'+ this.state.userData.token;
    }else if(this.props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product_prem/'+ this.state.userData.token;
    }
    
    let paymentDict;
    if(this.props.sourcePage === 'invoice'){
        paymentDict = {
            "source" : {'subtype': 'CASH', 'identifier': 'cash'},
            "shipping_data": {
                'apartment': this.state.deliveryData.apartment,
                'email': this.state.userData.order_email,
                'floor': this.state.deliveryData.floor,
                'first_name': this.getFirstName(this.state.userData.order_full_name),
                'street': this.state.deliveryData.street,
                'building': this.state.deliveryData.building,
                'phone_number': this.state.userData.order_phone,
                'postal_code': this.state.deliveryData.postal_code,
                'city': this.state.deliveryData.city,
                'country': this.state.deliveryData.country,
                'last_name': this.getLastName(this.state.userData.order_full_name),
                'state': this.state.deliveryData.state,
                'extra_description': this.state.deliveryData.notes
            },
            "shipping_details": {
                'delivery_type': 'payment_collection',
                'notes': this.state.deliveryData.notes
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integration_ids.CASH
        };
    }else if(this.props.sourcePage === 'product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": this.state.deliveryNeed,
                "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                "currency": this.state.userData.currency,
                "shipping_data": {
                    "first_name": this.getFirstName(this.state.deliveryData.name),
                    "last_name": this.getLastName(this.state.deliveryData.name),
                    "phone_number": this.state.deliveryData.phone,
                    "email": this.state.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": this.state.userData.product.product_name,
                    "amount_cents": this.state.userData.amount * 100,
                    "quantity": this.props.quantity,
                }]
            },
            "source" : {'subtype': 'CASH', 'identifier': 'cash'},
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integrations.CASH
        };
        paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
        paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
        paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
        paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
        paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
        paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
        paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
        paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
        paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
    }
    let jsonPaymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, jsonPaymentDict, config)
    .then((resp) => {
        if(resp.data.success === 'true' || resp.data.success === true){
            //succes without url and not delivery
            this.props.setReqComplete({icon:"delivery",head: 'Scheduling Successful', body:'Courrier will get in touch to determine the exact collection time.'});
        }else{
            //succes = false
            this.props.setReqComplete({head: '', body: resp.data.error});
        }
    })
    .catch((err) => {
        //--- end waiting
        this.setState({waiting: false});
        if(err.response.status === 404){
            alert('Please check your internet connection and try again.');
        }
    });
    event.preventDefault();
  }

  render() {
    return (
        <div className="premPanel deleveryForm">
            <div className="premHeader">
                <h2>CASH COLLECTION</h2>
                {
                    this.props.deliveryData.country?
                        <button onClick = {this.handleEdit}><i className="fa fa-pencil"></i>Edit</button>
                    :
                        null
                }

            </div>
            <div className="panel-body" id="card_content">
                {this.state.waiting?
                    <Waiting height="68px" />
                :
                    <div>
                        {
                            this.state.editBtn?
                                <CashSubData sourcePage='product'  userData={this.props.userData} setDeliveryData={this.props.setDeliveryData} currentDeliveryData={this.props.deliveryData} 
                                handleEdit = {this.handleEdit}
                                deliveryData={this.state.deliveryData}
                                />
                                :
                                <div>
                                    {
                                        this.props.deliveryData.country?
                                            <Form onSubmit={this.handleSubmit}>
                                                <div className="cashInfo">
                                                    <div className="cashDiv">
                                                        <h5>Full Name:</h5>
                                                        <p>{this.props.deliveryData.name}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>Email:</h5>
                                                        <p>{this.props.deliveryData.email}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>Phone Number:</h5>
                                                        <p>{this.props.deliveryData.phone}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>Country:</h5>
                                                        <p>{this.props.deliveryData.country}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>City:</h5>
                                                        <p>{this.props.deliveryData.city}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>State:</h5>
                                                        <p>{this.props.deliveryData.state}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>Street:</h5>
                                                        <p>{this.props.deliveryData.state}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>Building:</h5>
                                                        <p>{this.props.deliveryData.building}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>Floor:</h5>
                                                        <p>{this.props.deliveryData.floor}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>Apartment:</h5>
                                                        <p>{this.props.deliveryData.apartment}</p>
                                                    </div>
                                                    <div className="cashDiv">
                                                        <h5>Additional Info:</h5>
                                                        <p>{this.props.deliveryData.notes}</p>
                                                    </div>
                                                    {/* <cashSubData/> */}
                                                </div>
                                                <div className='text-center'>
                                                    <Button className="btn btn-primary active premBtn">Confirm</Button>
                                                </div>
                                            </Form> 
                                        :
                                        <CashSubData sourcePage='product'  userData={this.props.userData} setDeliveryData={this.props.setDeliveryData} currentDeliveryData={this.props.deliveryData}
                                        handleEdit = {this.handleEdit}
                                        deliveryData={this.state.deliveryData}
                                        />
                                    }
                                </div>
                        }
                    </div>
                }               
            </div>
        </div>
    );
  }
}

export default cash;
